import { render, staticRenderFns } from "./SSpacer.vue?vue&type=template&id=2836b060&scoped=true"
import script from "./SSpacer.vue?vue&type=script&lang=js"
export * from "./SSpacer.vue?vue&type=script&lang=js"
import style0 from "./SSpacer.vue?vue&type=style&index=0&id=2836b060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836b060",
  null
  
)

export default component.exports